import React from 'react';

import { Image } from '@zillow/constellation';

import { useGetGoogleMapsUrl } from '../../utils/apis/useGetGoogleMapsUrl';

const MAP_MARKER = 'https://nodes3cdn.hotpads.com/google-maps-icons/MapMarker_home.png';

type Props = {
  address: string;
  marginTop?: string | Record<string, string>;
  additionalMarkers?: string;
  size?: string;
  scale?: string | number;
};

// Copied from https://bitbucket.hotterpads.com/projects/RP/repos/rentals-js/browse/apps/zillow-rental-manager-web/app/shared/components/StaticMap/index.tsx
export function StaticMap({ address, additionalMarkers, size = '388x291', scale }: Props) {
  const encodedAddress = encodeURIComponent(address);
  const gmapsAPIParams = new URLSearchParams({
    center: encodedAddress,
    size,
    style: 'feature:poi|visibility:off',
    markers: `${additionalMarkers ? `${additionalMarkers}` : ''}&markers=icon:${MAP_MARKER}|${encodedAddress}`,
    ...(scale && { scale: String(scale) }),
  });

  const googleMapsUrl = `https://maps.googleapis.com/maps/api/staticmap?${gmapsAPIParams.toString()}`;
  const { data } = useGetGoogleMapsUrl(googleMapsUrl);

  return data && <Image src={data.data.signedUrl} alt={address} />;
}
